import React from 'react'
import { Outlet } from 'react-router-dom'
import { Sidebar, DashboardNavbar } from '@/components'

const DashboardLayout = () => {
  return (
    <div className="flex h-screen bg-background">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <DashboardNavbar />
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-background">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default DashboardLayout
